<template>
  <div>
    <v-card class="ma-3">
      <g-overlay :is-relay="isOverlay"/>
      <page-progress v-bind:is-loading="isLoading"/>
      <page-title icon="mdi-google-analytics" title="Google Analytics"/>
      <v-container class="pt-0" fluid>
        <v-row>
          <v-col cols="12" md="8" sm="12" xl="8" xs="12">
            <g-p-search
                class="mt-7"
                @applySearch="handleSearch"
            />
          </v-col>
          <v-col cols="12" md="12" v-if="googleData">
            <v-card
                class="mx-auto"
                max-width="500"
            >
              <v-card-text>
                <v-chip
                    v-if="googleData.domain"
                    class="ma-2"
                    color="primary"
                    link
                    @click.prevent.stop="openSite(googleData.domain)"
                >
                  {{ googleData.domain }}
                </v-chip>
                <p>Is Domain Indexed? <v-icon color="red" v-if="!googleData.isDomainIndex">mdi-window-close</v-icon> <v-checkbox v-else v-model="googleData.isDomainIndex" readonly></v-checkbox></p>
                <p>Is URL Indexed? <v-icon color="red" v-if="!googleData.isSiteUrlIndexed">mdi-window-close</v-icon> <v-checkbox v-else v-model="googleData.isSiteUrlIndexed" readonly></v-checkbox></p>

              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-container>
    </v-card>
  </div>
</template>

<script>
import GOverlay from "@/components/GOverlay";
import PageProgress from "@/components/PageProgress";
import PageTitle from "@/components/PageTitle";
import GPSearch from "@/components/GPSearch";
import GoogleAnalytics from "@/services/GoogleAnalytics"
export default {
  name: "GoogleAnalytics",
  components: {
    GPSearch,
    PageTitle,
    PageProgress,
    GOverlay
  },
  data() {
    return {
      isOverlay: false,
      isLoading: false,
      googleData: null
    }
  },
  methods: {
    handleSearch(terms) {
      this.googleData = null;
      if(!terms) return;
      this.setLoader();
      GoogleAnalytics.checkIndex({siteUrl: terms})
          .then((response) => {
            this.googleData = response.data;
            this.unsetLoader();
          })
          .catch((errors) => {
            this.setSnackBar({text: errors.response.data.message, type: 'error'});
            this.unsetLoader();
          })
    },
    setLoader() {
      this.isLoading = true;
      this.isOverlay = true;
    },
    unsetLoader() {
      this.isLoading = false;
      this.isOverlay = false;
    },
    setSnackBar({text,type}) {
      this.$store.commit('SET_SNACKBAR', {text,type});
    },
    openSite(site) {
      window.open(site, '_blank');
    },
  }
}
</script>

<style scoped>

</style>